/** biome-ignore-all lint/a11y/useSemanticElements: cards act as radio */
import {
  Card,
  Icon,
  type IconName,
  Inline,
  omniConfig,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import type { PaymentMethod } from '@omnipresentgroup/types';
import type { ReactElement } from 'react';

export type PaymentMethodCardDetails = {
  title: string;
  description?: string;
  iconName: IconName;
  tag?: ReactElement;
  disabled?: boolean;
};

type Props = {
  paymentMethod: PaymentMethod;
  selected?: boolean;
  onClick?: (paymentMethod: PaymentMethod) => void;
} & PaymentMethodCardDetails;

export const PaymentMethodCard = ({
  paymentMethod,
  selected,
  onClick,
  disabled,
  iconName,
  title,
  description,
  tag,
}: Props) => {
  return (
    <Card
      role="radio"
      interactive="true"
      aria-labelledby={paymentMethod}
      selected={selected}
      disabled={disabled}
      onClick={onClick ? () => onClick(paymentMethod) : undefined}
    >
      <Stack bg={disabled ? 'page' : 'primary'} p="16">
        <Inline align="center" justify="space-between">
          <Inline align="center">
            <Icon
              size="24"
              color={selected ? 'neutral' : 'default'}
              style={{
                borderWidth: selected
                  ? omniConfig.theme.borderWidths.m
                  : omniConfig.theme.borderWidths.s,
                borderStyle: omniConfig.theme.borderStyles.solid,
                borderColor: disabled
                  ? omniConfig.theme.colors['icon-disabled']
                  : // eslint-disable-next-line unicorn/no-nested-ternary
                    selected
                    ? omniConfig.theme.colors['icon-neutral']
                    : omniConfig.theme.colors['icon-default'],
                borderRadius: omniConfig.theme.radii.full,
                padding: omniConfig.theme.space[8],
              }}
              icon={iconName}
            />
            <Stack gap="0">
              <Typography
                as="h4"
                hideParagraphSpacing
                size="16"
                weight="medium"
                color={disabled ? 'subtle' : 'default'}
              >
                {title}
              </Typography>
              <Typography as="span" size="14" color="subtle">
                {description}
              </Typography>
            </Stack>
          </Inline>
          {tag && <Inline>{tag}</Inline>}
        </Inline>
      </Stack>
    </Card>
  );
};
